import { setLoading } from "../stores/loading";
import { handleError } from "./error";

export async function execAsync(
    func,
    { loading = true, loadingMessage, errorHandler, args = [] } = {}
) {
    if (loading) setLoading(true, loadingMessage);
    let error;
    try {
        if (errorHandler) await func().catch(errorHandler);
        else await func(...args);
    } catch (e) {
        error = e;
        handleError(e);
    } finally {
        if (loading) setLoading(false);
        if (error) throw error;
    }
}

export function handleAsync(
    func,
    { loading = true, loadingMessage, errorHandler } = {}
) {
    return (...args) =>
        execAsync(func, { loading, loadingMessage, errorHandler, args });
}
